import(/* webpackMode: "eager" */ "/root/medallion-homes/node_modules/next/dist/client/script.js");
